// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".truncate[data-v-083924dc]{overflow:hidden;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:block-axis;vertical-align:middle;min-height:2rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
